/*eslint-disable */
import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useDropzone } from 'react-dropzone'
import { IconButton, Button, Grid, Link, Alert, Radio, RadioGroup, 
  FormControlLabel, FormControl, Tooltip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ButtonWithLoader from '../../../../components/buttonWithLoader'

import { useNavigate } from 'react-router-dom'

import { CREATION_TEMPLATE, UPLOAD_TYPES, EXCEL_ROW_OFFSET } from "./bulkUsersUpload.constants";

// helpers
import { bytesToSize } from './bulkUsersUpload.helpers'
import { csvToJson } from '../../../../helpers/general'
import { validateJson } from './bulkUsersUpload.helpers'
import { bulkUserUpload } from '../../../../store/reducers/uploadRequestsSlice'
import ConfirmationDialog from '../../../../components/confirmationDialog'
import useDialogVisibility from '../../../../hooks/useDialogVisibility'

// selectors
import { useSelector, useDispatch } from 'react-redux'
import {
  selectBulkStatus,
  selectBulkFileName,
  selectBulkError,
  selectJobId,
} from '../../../../store/selectors/uploadRequests'

// assets
import creationTemplate from '../../../../assets/creation_template.csv'
import reactivationTemplate from '../../../../assets/reactivation_template.csv'
import fileImage from '../../../../assets/Wrapper.png'
import one from '../../../../assets/circledOne.png'
import two from '../../../../assets/circledTwo.png'
import download from '../../../../assets/Icon end.png'

// styles
import styles from './bulkUsersUpload.module.scss'

import { Modal } from '../../../../components/modal/modal'
import { ProgressBar } from '../../../../components/progressBar/progressBar'
import WarningsModal from './components/warningsModal'
import { useTranslation } from 'react-i18next'
import { ContentCopy } from '@mui/icons-material'


const dropzoneStyle = {
  border: '2px dashed #C1BBB3',
  borderRadius: '4px',
  padding: '20px',
  textAlign: 'center',
  cursor: 'auto',
  backgroundColor: '#FFFFFF',
  width: '496px',
  height: '160px',
  marginTop: '15px',
  marginLeft:'45px',
}

const downloadTemplateStyle = {
  height: '40px',
  width: '257px',
  borderRadius: '28px',
  backgroundColor: '#EB1700',
  cursor: 'pointer',
}

const linkStyle = {
  color: 'white',
  cursor: 'pointer',
  marginTop: '6px',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  textDecoration: 'none',
}

const bannerStyle = {
  border: '1px solid #E8E6E3',
  width: '70%',
  height: '50px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '10px',
}

const fileImageStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}

const cancelStyle = {
  backgroundColor: 'rgba(98, 81, 55, 0.1)',
  '&:hover': {
    backgroundColor: 'rgba(102,90,71, 0.20)',
  },
  '&:disabled': {
    backgroundColor: 'rgba(138, 115, 92, 0.05)',
  },
  '&:focus': {
    backgroundColor: 'rgba(112, 99, 79, 0.1)',
  },
}

const submitStyle = {
  backgroundColor: '#eb1700',
  '&:hover': {
    backgroundColor: '#CC1400',
  },
  '&:disabled': {
    backgroundColor: '#5A514426',
  },
  '&:focus': {
    backgroundColor: '#CC1400',
  },
}

const BulkUsersUpload = () => {
  const navigate = useNavigate()
  const [file, setFile] = useState(null)
  const [isValidating, setIsValidating] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [uploadType,setUploadType] = useState(CREATION_TEMPLATE.id)
  const [users, setUsers] = useState([])
  const [error, setError] = useState('')
  const [warning, setWarning] = useState('')
  const [showFileUploadWarning, setShowFileUploadWarning] = useState(true)
  const [showWarningsModal, setShowWarningsModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [showBulkUploadSuccessBanner, setShowBulkUploadSuccessBanner] = useState(false)
  const [showBulkUploadWarningBanner, setShowBulkUploadWarningBanner] = useState(false)
  const [fileReadyForUpload, setFileReadyForUpload] = useState(false)
  const [
    isCancelConfirmationDialogOpen,
    openCancelConfirmationDialog,
    closeCancelConfirmationDialog,
  ] = useDialogVisibility(false)

  const bulkUploadStatus = useSelector(selectBulkStatus)
  const bulkUploadError = useSelector(selectBulkError);
  const uploadedFileName = useSelector(selectBulkFileName)
  const jobId = useSelector(selectJobId)

  const setAsValidated = () => setIsValidating(false)
  const setAsSubmitted = () => setIsSubmitting(false)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = () => setIsModalOpen(true)
  const { t } = useTranslation();
  
  const closeModal = (event, reason) => {
    if (reason !== 'backdropClick') {
      setIsModalOpen(false)
    }
  }

  const handleRadioChange = (e) => {
    const { value } = e.target;
    setUploadType(value)
  }

  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (isModalOpen === true) {
      const timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress === 99) {
            return 99
          }
          const diff = Math.random() * 20
          return Math.min(oldProgress + diff, 99)
        })
      }, 100)

      return () => {
        clearInterval(timer)
      }
    } else {
      setProgress(0)
    }
  }, [isModalOpen])

  let modalChildren
  if (bulkUploadStatus === 'failed') {
    modalChildren = (
      <div>
        <span className={styles.failedSubmitTitle}>
          <WarningAmberIcon style={{ color: 'orange', marginRight: '1%' }} />
          Upload failed
        </span>
        <div className={styles.failedSubmitMsg}>{error}</div>
        <Button
          onClick={setAsSubmitted}
          className={styles.okButton}
          variant="contained"
          disabled={false}
          sx={{ marginTop: '20px', marginLeft: '10px' }}
        >
          OK
        </Button>
      </div>
    )
  } else {
    modalChildren = (
      <div className={styles.bulkModal}>
        <div className={styles.fileSubmittingTitle}>{ t('bulk-upload-submitting-your-file') }</div>
        <ProgressBar
          variant={'determinate'}
          value={progress}
          color={'#7d7f7c'}
        />
        <div className={styles.fileSubmittingMsg}>{t('bulk-upload-file-name')}: {file?.name}</div>
      </div>
    )
  }

  const onDrop = (acceptedFiles) => {
    if (fileReadyForUpload) {
      // there is already a file that has been uploaded+validated ready to submit; reject
      toast.error(t('bulk-upload-please-upload-one-file-at-a-time'))
      return
    } else {
      const file = acceptedFiles[0]
      if (!file.name.endsWith('.csv')) {
        toast.error(t('bulk-upload-invalid-file-type'))
        return
      }
      if (file?.size > 220000) {
        toast.error(t('bulk-upload-max-allowed-file-size'))
        return
      }
      setIsValidating(true)
      setFile(acceptedFiles[0])
      resetWarning()
      closeBulkUploadSuccessBanner()
      csvToJson(acceptedFiles[0])
        .then((res) => {
          const { validUsers, invalidUsersIndex, validationErrors } =
            validateJson(res, uploadType)
          if (invalidUsersIndex.length > 0) {
            const invalidUsersIndexString = invalidUsersIndex
              .map((index) => index + EXCEL_ROW_OFFSET)
              .join()
            setWarning(invalidUsersIndexString)
            setValidationErrors(validationErrors)
          }
          setError('')
          setUsers(validUsers)
          setFileReadyForUpload(true)
        })
        .catch((err) => {
          setError(err?.message)
          setFileReadyForUpload(false)
        })
        .finally(setAsValidated)
    }
  }

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    acceptedFiles: '.csv', // Specify allowed file types
    multiple: false,
    maxFiles: 1,
    noClick: true,
  })

  const handleBulkUploadUsersSuccess = () => {
    setShowBulkUploadSuccessBanner(true)
    setShowBulkUploadWarningBanner(true)
  }

  const dispatch = useDispatch()

  const handleUpload = async (event) => {
    setIsSubmitting(true)
    event.preventDefault();
    const formData = new FormData();
    if(uploadType === "REACTIVATION_TEMPLATE"){
      formData.append('operation', 'reactivate_users');
    }else{
      formData.append('operation', 'upsert_users');
    }
    formData.append('file', file);
    dispatch(bulkUserUpload(formData))
  }

  useEffect(() => {
    if (isSubmitting) {
      setIsModalOpen(true)
      if (bulkUploadStatus === 'succeeded') {
        handleBulkUploadUsersSuccess()
        setFileReadyForUpload(false)
        setFile(null)
        setIsSubmitting(false)
      } else if (bulkUploadStatus === 'failed') {
        const errorMessage = bulkUploadError 
        || `Your file "${file.name}" failed to submit. Please try again.`; 
        setError(errorMessage)
        setFileReadyForUpload(false)
        setFile(null)
        setIsSubmitting(false)
      }
    } else {
      setIsModalOpen(false)
    }
  }, [bulkUploadStatus, isSubmitting])

  const onCancel = () => {
    openCancelConfirmationDialog()
  }

  const handleSubmitCancelConfirmationDialog = () => {
    setWarning('')
    setValidationErrors([])
    setError('')
    setIsSubmitting(false)
    setFileReadyForUpload(false)
    setFile(null)
    navigate('/')
  }

  const resetError = () => {
    setError('')
    setFile('')
  }

  const resetWarning = () => {
    setWarning('')
    setValidationErrors([]);
  }

  const closeBulkUploadSuccessBanner = () => {
    setShowBulkUploadSuccessBanner(false)
  }

  const closeBulkUploadWarningBanner = () => {
    setShowBulkUploadWarningBanner(false)
  }

  return (
    <div>
      <Modal
        children={modalChildren}
        closeButton={false}
        isOpen={isModalOpen}
        closeModalFunc={closeModal}
      />
      {showFileUploadWarning && <Alert
          severity="warning"
          onClose={() => setShowFileUploadWarning(false)}
          style={{ margin: '10px 0px' }}
        >
          <span>{t('warning-upload')}</span>
          <span style={{cursor: "pointer", color: "blue", textDecoration: "underline"}} onClick={() =>navigate("/bulk-users-activity")}>{t('click-to-check')}</span>
      </Alert>}
      {error && (
        <Alert
          severity="error"
          onClose={resetError}
          style={{ margin: '10px 0px' }}
        >
          {error}
        </Alert>
      )}
      {warning && (
        <Alert
          severity="warning"
          onClose={resetWarning}
          style={{ margin: '10px 0px' }}
        >
         <div style={{display: 'flex'}}>
          <span>{t('users-in-row')} &nbsp;</span>
          <span>
              {warning.substring(19, 20) ? <Tooltip title={warning}>
                  <span style={{cursor: 'pointer'}}>{`${warning.substring(0, 19)} etc..`}</span> 
            </Tooltip> : <>{warning}</>}
            &nbsp;
          </span>
          <span>{t('invalid-details')} &nbsp;</span>
          <span style={{cursor: "pointer", color: "blue", textDecoration: "underline"}} onClick={() => setShowWarningsModal(true)}>{ t('bulk-upload-click-here-to-view') }</span>
         </div> 
        </Alert>
      )}
      {showBulkUploadSuccessBanner && (
        <Alert
          severity="success"
          onClose={closeBulkUploadSuccessBanner}
          style={{ margin: '10px 0px' }}
        >
          {`${t('success-message')} ${jobId}`}
        </Alert>
      )}
      {showBulkUploadWarningBanner && (
        <Alert
        severity="warning"
        onClose={closeBulkUploadWarningBanner}
        style={{display: 'flex'}}
        sx={{
          "& .MuiAlert-message":{
            width: "100%",
          }
        }}
        >
          <div style={{display: 'flex', justifyContent:"space-between"}}>
          <strong>{t('warning-upload-title')}</strong>
          <Link
            href={`/view-bulk-job/${jobId}`}
            style={{textDecoration: 'none'}}
          >
          {t('warning-file-upload-status')}
          </Link>
          </div>
          <p>{t('warning-copy-job-id-1')}{jobId} <br/>{t('warning-copy-job-id-2')}</p>
          <Button variant='outlined' startIcon={<ContentCopy/>} color='info' onClick={() => {navigator.clipboard.writeText(jobId)}} 
          sx={{
              borderRadius: '12px', 
              color:"#000", 
              borderColor:"#000",
              "&:hover":{
                borderColor: "#000",
                backgroundColor: "rgba(46, 46, 46, 0.04);"
              }}}>
            {t('warning-copy-job-id-button-label')}
          </Button>
        </Alert>
      )}
      <div style={{display: "flex", flexDirection: "column", marginLeft: "30px"}}>
        <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="gender"
              value={uploadType}
              onChange={handleRadioChange} 
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {UPLOAD_TYPES.map(uploadTypeOption => 
              <FormControlLabel 
                value={uploadTypeOption.id} 
                control={<Radio style={{color:"black"}} sx={{color:'black'}}/>} 
                label={uploadTypeOption.name === "Create new bulk user" ? t('create-new-bulk') : t('reactivate-new-bulk')}  
                sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: '15.83px',
                },
                '& .MuiFormControlLabel-label': 
                { fontSize: '14px' } }} 
              />)}
            </RadioGroup>

          </FormControl>
          
          <h3>
            <span style={{display: 'flex', alignItems: 'center', gap: 10, fontSize: '14px'}}>
              <img src = {one} alt='1' style={{ verticalAlign: 'middle', height: '36px', width:'36px' }}/>
              {t('download-and-use')}
              {uploadType === "REACTIVATION_TEMPLATE" ? t('reactivation') : t('creation')}
            </span>
          </h3>
          <div style={{display: 'flex', paddingLeft: '45px', fontSize:'14px'}}>
            <div style={downloadTemplateStyle}>
                <Link
                  style={linkStyle}
                  href={uploadType === "REACTIVATION_TEMPLATE" ? reactivationTemplate : creationTemplate}
                  download={uploadType === "REACTIVATION_TEMPLATE" ? "reactivate_bulk_users_template.csv" : "create_bulk_users_template.csv"}
                >
                  <span style={{paddingTop:'3px', paddingRight:'5px', paddingLeft:'10px'}}>
                  {uploadType === "REACTIVATION_TEMPLATE" ? t('download-reactivation-template') : t('download-creation-template')}
                  </span>
                  <img src = {download} alt='1' style={{ verticalAlign: 'middle', height: '24px', width:'24px' }}/>
                  
                </Link>
            </div>
          </div>
          <h3>
            <span style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: '14px' }}>
            <img src = {two} alt='1' style={{ verticalAlign: 'middle', height: '36px', width:'36px'}}/>
            {t('select-and-upload')}
            </span>
          </h3>
          <div {...getRootProps()} style={dropzoneStyle}>
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>{t('drop-the-file')}</p>
            ) : (
              //drag and drop
              <div className={styles.drag} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <ArrowUpwardIcon onClick={open} style={{ cursor: 'pointer', color: '#564C47', marginBottom: 10, marginTop:15 }} />
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 5, marginTop: 6, fontSize: '14px'}}>
                  <span className={styles.browse} onClick={open} >
                    {' '}
                    {t('click-to-upload')} {' '}
                  </span> 
                  <span className={styles.dragDrop}>
                  {t('drag-and-drop')}
                  </span>{' '}
                &nbsp;
                </div>
              </div>
            )}
            <div
              onClick={(event) => event?.stopPropagation()}
              className={styles.downloadMsg}
            >
              <p style={{color: '#564C47', marginTop:6, fontSize:'12px'}}>{t('supported-formats')}</p>
            </div>
            
          </div>
          <div>
            {file?.name && !error && (
              <div style={bannerStyle}>
                <div style={fileImageStyle}>
                  <img src={fileImage} width="25" height="25" />
                  <div
                    style={{
                      marginLeft: '10px',
                      textDecoration: 'none',
                      fontWeight: '700',
                    }}
                  >
                    {`${file?.name} ${
                      isValidating ? t('uploading') : bytesToSize(file.size)
                    }`}{' '}
                  </div>
                </div>
                <div>
                  <IconButton
                    size="small"
                    color="inherit"
                    onClick={onCancel}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </div>
              </div>
            )}
            <Grid style={{marginLeft:'45px', marginTop:'30px'}}>
              <ButtonWithLoader
                onClick={handleUpload}
                loading={isSubmitting}
                disabled={!file?.name || isValidating || isSubmitting || error}
                label={t('submit')}
                className="secondary-btn"
                sx={{
                  ...submitStyle,
                  marginTop: '20px',
                  width: '120px',
                  height: '42px',
                }}
              />
              <Button
                onClick={onCancel}
                type="submit"
                className={!file?.name ? 'secondary-btn':'primary-btn' }
                variant="contained"
                disableElevation={true}
                sx={{
                  ...cancelStyle,
                  marginTop: '20px',
                  marginLeft: '10px',
                  width: '120px',
                  height: '42px',
                  color: '#000000',
                }}
              >
                {t('cancel')}
              </Button>
            </Grid>
          </div>
      </div>
     <WarningsModal 
        showModal={showWarningsModal}
        setShowModal={setShowWarningsModal} 
        validationErrors={validationErrors}
        fileName={file?.name}
        uploadType={uploadType}
      />
      <ConfirmationDialog
        showDialog={isCancelConfirmationDialogOpen}
        onSubmit={handleSubmitCancelConfirmationDialog}
        onCancel={closeCancelConfirmationDialog}
      />
    </div>
  )
}

export default BulkUsersUpload
